import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ReferenciasPersonalesDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class ReferenciasPersonalesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getReferenciasPersonalesService(): Observable<BodyListResponse<ReferenciasPersonalesDTO>> {
    return this.http.get<BodyListResponse<ReferenciasPersonalesDTO>>(API_URL + '/api/v1/referenciasPersonales/todos');
  }

  guardarReferenciasPersonalesService(referenciasPersonalesDTO: ReferenciasPersonalesDTO): Observable<ReferenciasPersonalesDTO> {
    return this.http.post<ReferenciasPersonalesDTO>(API_URL + '/api/v1/referenciasPersonales', referenciasPersonalesDTO);
  }

  getReferenciasPersonalesPorCodigoReferenciaPersonalService(codigoReferenciaPersonal: string): Observable<BodyResponse<ReferenciasPersonalesDTO>> {
    return this.http.get<BodyResponse<ReferenciasPersonalesDTO>>(API_URL + '/api/v1/referenciasPersonales/' + codigoReferenciaPersonal);
  }

  getReferenciasPersonalesPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<ReferenciasPersonalesDTO>> {
        return this.http.get<BodyListResponse<ReferenciasPersonalesDTO>>(API_URL + '/api/v1/referenciasPersonales/persona/' + codigoPersona);
   }
}
